import React from 'react'

/**
 * Walks a React element tree looking for sentinel characters (☐/☑) in text
 * node props. These are injected during task list preprocessing and indicate
 * checked/unchecked checkbox items.
 *
 * Checks props.literal (commonmark text nodes) and props.children (React text nodes).
 */
export const findTaskState = (node: React.ReactNode): 'checked' | 'unchecked' | null => {
  if (typeof node === 'string') {
    if (node.startsWith('☑')) {
      return 'checked'
    }
    if (node.startsWith('☐')) {
      return 'unchecked'
    }
    return null
  }
  if (Array.isArray(node)) {
    for (const child of node) {
      const result = findTaskState(child)
      if (result) {
        return result
      }
    }
    return null
  }
  if (!React.isValidElement(node)) {
    return null
  }
  const props = node.props as Record<string, unknown>
  if (typeof props.literal === 'string') {
    if (props.literal.startsWith('☑')) {
      return 'checked'
    }
    if (props.literal.startsWith('☐')) {
      return 'unchecked'
    }
  }
  if (typeof props.children === 'string') {
    if (props.children.startsWith('☑')) {
      return 'checked'
    }
    if (props.children.startsWith('☐')) {
      return 'unchecked'
    }
  }
  return findTaskState(props.children as React.ReactNode)
}
